import React, { forwardRef, useContext } from 'react';
import styles from '../Input.module.css';
import { InputContext } from '../Input';
import {
  passthroughChildrenWithDisabledState,
  isButtonElement,
  isIconButtonElement,
} from '../__utils';

interface SlotProps {
  children: React.ReactNode;
  className?: string;
  increment?: boolean | object;
  decrement?: boolean | object;
}

const InputEndSlot = forwardRef<HTMLDivElement, SlotProps>(
  ({ children, className, increment, decrement }, ref) => {
    const state = useContext(InputContext);
    let processedChildren = passthroughChildrenWithDisabledState(
      children,
      state.isDisabled,
    );

    // If increment or decrement prop is present, clone the button child with those props
    if (increment || decrement) {
      processedChildren = React.Children.map(children, (child) => {
        if (
          React.isValidElement(child) &&
          (isButtonElement(child) || isIconButtonElement(child))
        ) {
          return React.cloneElement(child, {
            type: 'button',
            ...(typeof increment === 'object' && increment !== null
              ? increment
              : {}),
            ...(typeof decrement === 'object' && decrement !== null
              ? decrement
              : {}),
          });
        }
        return child;
      });
    }

    return (
      <div
        ref={ref}
        className={[styles['input-field__endSlot'], className || '']
          .filter(Boolean)
          .join(' ')}
        {...(state.isDisabled ? { 'data-disabled': true } : {})}
        {...(state.isInvalid ? { 'data-invalid': true } : {})}
        data-end-slot-button={
          React.Children.toArray(children).some(isButtonElement)
            ? 'true'
            : undefined
        }
      >
        {processedChildren}
      </div>
    );
  },
);
InputEndSlot.displayName = 'Input.EndSlot';

export default InputEndSlot;
